export enum roles {
  teacher = 'teacher',
  dispatcher = 'dispatcher',
  extramuralDispatcher = 'extramuralDispatcher',
  admin = 'admin',
  worker = 'worker',
  student = 'student',
  departmentHead = 'departmentHead',
  departmentDispatcher = 'departmentDispatcher',
  placeOwner = 'placeOwner',
  stats = 'stats'
}

export const rolesTranslation: { [k: string]: string } = {
  [roles.teacher]: 'Преподаватель',
  [roles.admin]: 'Администратор',
  [roles.student]: 'Студент',
  [roles.stats]: 'УОО'
}

export const rolesBadges: { [k: string]: string } = {
  [roles.teacher]: 'Преп',
  [roles.admin]: 'Адм',
  [roles.student]: 'Студ',
  [roles.stats]: 'УОО'
}

export enum GroupRoles {
  student = 'student',
  leader = 'leader'
}

export enum DepartmentRoles {
  depHead = 'depHead'
}

export enum FacultyRoles {
  dean = 'dean'
}
